<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Duplicate BillNo management system" name="description"/>
      <meta content="County System" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.svg" rel="shortcut icon">
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Duplicate BillNo Management</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboard</a></li>
                      <li class="breadcrumb-item"><a>Admin Tools</a></li>
                      <li class="breadcrumb-item active">Duplicate BillNo</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tab Navigation -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <ul class="nav nav-tabs" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link"
                           :class="{ active: activeTab === 'duplicates' }"
                           @click="activeTab = 'duplicates'"
                           href="javascript:void(0);">
                          <i class="bx bx-copy me-2"></i>
                          Find Duplicate BillNos
                          <span v-if="duplicatesFound > 0" class="badge bg-danger ms-2">{{ duplicatesFound }}</span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                           :class="{ active: activeTab === 'archived' }"
                           @click="activeTab = 'archived'"
                           href="javascript:void(0);">
                          <i class="bx bx-archive me-2"></i>
                          Archived Records
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Duplicates Tab -->
            <div v-if="activeTab === 'duplicates'">
              <!-- Summary Cards -->
              <div class="row mb-4">
                <div class="col-md-3">
                  <div class="card mini-stats-wid border-warning">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Duplicate BillNos</p>
                          <h4 class="mb-0 text-warning">{{ duplicatesFound }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                            <span class="avatar-title">
                              <i class="bx bx-copy font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="card mini-stats-wid border-info">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Unique BillNos Affected</p>
                          <h4 class="mb-0 text-info">{{ uniqueBillNos }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                            <span class="avatar-title">
                              <i class="bx bx-group font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="card mini-stats-wid border-danger">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Total Amount</p>
                          <h4 class="mb-0 text-danger">{{ formatPrice(duplicateAmount) }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-danger">
                            <span class="avatar-title">
                              <i class="bx bx-money font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="card mini-stats-wid border-success">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Selected</p>
                          <h4 class="mb-0 text-success">{{ selectedBillNos.length }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                            <span class="avatar-title">
                              <i class="bx bx-check-square font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Filters -->
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-light">
                      <h4 class="card-title mb-0">Search for Duplicate BillNo Records</h4>
                    </div>
                    <div class="card-body">
                      <div class="row g-3">
                        <div class="col-md-3">
                          <label class="form-label">From Date:</label>
                          <input v-model="filters.dateFrom"
                                 class="form-control"
                                 type="date"
                                 @change="clearResults">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">To Date:</label>
                          <input v-model="filters.dateTo"
                                 class="form-control"
                                 type="date"
                                 @change="clearResults">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Revenue Stream:</label>
                          <select class="form-select" v-model="filters.incomeTypePrefix" @change="clearResults">
                            <option value="">All Streams</option>
                            <option v-for="prefix in prefixes" :key="prefix.incomeTypePrefix" :value="prefix.incomeTypePrefix">
                              {{ prefix.stream }} ({{ prefix.incomeTypePrefix }})
                            </option>
                          </select>
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Sub County:</label>
                          <select class="form-select" v-model="filters.subCountyID" @change="clearResults">
                            <option value="">All Sub Counties</option>
                            <option v-for="county in subCounties" :key="county.subCountyID" :value="county.subCountyID">
                              {{ county.subCountyName }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Quick Date Filters -->
                      <div class="mt-3">
                        <label class="form-label">Quick Filters:</label>
                        <div class="btn-group me-3" role="group">
                          <button @click="setDateRange('today')" type="button" class="btn btn-outline-primary btn-sm">Today</button>
                          <button @click="setDateRange('week')" type="button" class="btn btn-outline-primary btn-sm">This Week</button>
                          <button @click="setDateRange('month')" type="button" class="btn btn-outline-primary btn-sm">This Month</button>
                        </div>

                        <button @click="searchDuplicateBillNos()"
                                type="button"
                                class="btn btn-primary"
                                :disabled="loading || !filters.dateFrom || !filters.dateTo">
                          <i class="bx bx-search me-1"></i>
                          <span v-if="loading">Searching...</span>
                          <span v-else>Find Duplicate BillNos</span>
                        </button>

                        <button @click="openAutoArchiveModal()"
                                type="button"
                                class="btn btn-warning ms-2"
                                :disabled="autoArchiveInProgress || autoArchivePaused">
                          <i class="bx bx-time me-1"></i>
                          <span v-if="autoArchiveInProgress">Running...</span>
                          <span v-else-if="autoArchivePaused">Paused</span>
                          <span v-else>Auto Archive</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Results Table -->
              <div v-if="duplicates.length > 0" class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">
                        Duplicate BillNos Found ({{ duplicatesFound }} duplicates to remove)
                      </h4>
                      <div class="btn-group">
                        <button @click="selectAllDuplicates()"
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                :disabled="duplicatesOnly.length === 0">
                          <i class="bx bx-select-multiple me-1"></i>
                          Select All Duplicates
                        </button>
                        <button @click="clearSelection()"
                                type="button"
                                class="btn btn-sm btn-outline-secondary"
                                :disabled="selectedBillNos.length === 0">
                          <i class="bx bx-x me-1"></i>
                          Clear Selection
                        </button>
                        <button @click="showBulkArchiveConfirmation()"
                                type="button"
                                class="btn btn-sm btn-danger"
                                :disabled="selectedBillNos.length === 0 || archiving">
                          <i class="bx bx-archive me-1"></i>
                          <span v-if="archiving">Archiving...</span>
                          <span v-else>Archive Selected ({{ selectedBillNos.length }})</span>
                        </button>
                      </div>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0">
                          <thead class="table-light">
                          <tr>
                            <th width="50">
                              <input type="checkbox"
                                     class="form-check-input"
                                     @change="toggleSelectAllVisible"
                                     :checked="allVisibleDuplicatesSelected">
                            </th>
                            <th>Bill No</th>
                            <th>Type</th>
                            <th>Record ID</th>
                            <th>Customer</th>
                            <th>Fee Description</th>
                            <th>Amount</th>
                            <th>Date Created</th>
                            <th>Occurrence Count</th>
                            <th>Actions</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="item in duplicates"
                              :key="item.id"
                              :class="{
                                  'table-success': item.record_type === 'FIRST_RECORD',
                                  'table-warning': item.record_type === 'DUPLICATE_BILLNO' && selectedBillNos.includes(item.id),
                                  'table-light': item.record_type === 'DUPLICATE_BILLNO'
                                }">
                            <td>
                              <input v-if="item.record_type === 'DUPLICATE_BILLNO'"
                                     type="checkbox"
                                     class="form-check-input"
                                     :value="item.id"
                                     v-model="selectedBillNos">
                              <span v-else class="text-success fw-bold">✓</span>
                            </td>
                            <td>
                              <strong>{{ item.billNo }}</strong>
                              <br>
                              <small class="text-muted">{{ item.incomeTypePrefix }}</small>
                            </td>
                            <td>
                                <span v-if="item.record_type === 'FIRST_RECORD'"
                                      class="badge bg-success">FIRST RECORD</span>
                              <span v-else class="badge bg-warning text-dark">DUPLICATE #{{ item.sequence_number }}</span>
                            </td>
                            <td>
                              <code>{{ item.id }}</code>
                            </td>
                            <td>
                              <strong>{{ item.names }}</strong>
                              <br>
                              <small class="text-muted">ID: {{ item.idNo }}</small>
                              <br>
                              <small class="text-muted">{{ item.customerPhoneNumber }}</small>
                            </td>
                            <td>
                              {{ item.feeDescription }}
                              <br>
                              <small class="text-muted">{{ item.subCountyName }} - {{ item.wardName }}</small>
                            </td>
                            <td>
                              <strong class="text-danger">{{ formatPrice(item.detailAmount) }}</strong>
                            </td>
                            <td>
                              {{ formatDateTime(item.dateCreated) }}
                            </td>
                            <td>
                              <span class="badge bg-info">{{ item.occurrence_count }}x</span>
                            </td>
                            <td>
                              <button v-if="item.record_type === 'DUPLICATE_BILLNO'"
                                      @click="showSingleArchiveConfirmation(item)"
                                      class="btn btn-sm btn-danger"
                                      :disabled="archiving">
                                <i class="bx bx-trash"></i>
                              </button>
                              <span v-else class="text-muted">Keep</span>
                            </td>
                          </tr>
                          </tbody>
                          <tfoot v-if="duplicates.length > 0" class="table-dark">
                          <tr>
                            <th colspan="6">
                              <strong>{{ duplicates.length }} records ({{ duplicatesFound }} duplicates)</strong>
                            </th>
                            <th>
                              <strong>{{ formatPrice(duplicateAmount) }}</strong>
                            </th>
                            <th colspan="3"></th>
                          </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- No Results -->
              <div v-else-if="!loading && searched" class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body text-center py-5">
                      <i class="bx bx-check-circle text-success" style="font-size: 72px;"></i>
                      <h4 class="mt-3">No Duplicate BillNos Found</h4>
                      <p class="text-muted">No bills with duplicate billNo were found in the selected date range.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Archived Tab -->
            <div v-if="activeTab === 'archived'">
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-light">
                      <h4 class="card-title mb-0">Archived BillNo Records</h4>
                    </div>
                    <div class="card-body">
                      <div class="alert alert-info">
                        <i class="bx bx-info-circle me-2"></i>
                        Archived records history coming soon
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Footer -->
        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                  Duplicate BillNo Management
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <!-- Single Archive Confirmation Modal -->
    <div class="modal fade" id="singleArchiveConfirmationModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title text-white">Confirm Archive</h5>
            <button type="button" class="btn-close btn-close-white" @click="closeSingleArchiveModal"></button>
          </div>
          <div class="modal-body" v-if="currentArchiveRecord">
            <div class="alert alert-warning">
              <i class="bx bx-info-circle me-2"></i>
              <strong>Warning:</strong> You are about to archive this duplicate billNo record.
              The first/original record will be kept.
            </div>

            <div class="card border">
              <div class="card-body">
                <h6 class="mb-3">Record to Archive:</h6>
                <div class="row g-2">
                  <div class="col-6">
                    <small class="text-muted">Record ID:</small><br>
                    <strong>{{ currentArchiveRecord.id }}</strong>
                  </div>
                  <div class="col-6">
                    <small class="text-muted">BillNo:</small><br>
                    <strong>{{ currentArchiveRecord.billNo }}</strong>
                  </div>
                  <div class="col-6">
                    <small class="text-muted">Customer:</small><br>
                    {{ currentArchiveRecord.names }}
                  </div>
                  <div class="col-6">
                    <small class="text-muted">Amount:</small><br>
                    <strong>{{ formatPrice(currentArchiveRecord.detailAmount) }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3">
              <label class="form-label">Archive Reason (Optional):</label>
              <input type="text"
                     class="form-control"
                     v-model="singleArchiveReason"
                     placeholder="Enter reason...">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeSingleArchiveModal">Cancel</button>
            <button type="button" class="btn btn-danger" @click="archiveSingle()" :disabled="archiving">
              <i class="bx bx-archive me-1"></i>
              <span v-if="archiving">Archiving...</span>
              <span v-else>Archive Record</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Bulk Archive Confirmation Modal -->
    <div class="modal fade" id="bulkArchiveConfirmationModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title text-white">Confirm Bulk Archive</h5>
            <button type="button" class="btn-close btn-close-white" @click="closeBulkArchiveModal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <i class="bx bx-error me-2"></i>
              <strong>Warning:</strong> You are about to archive {{ selectedBillNos.length }} duplicate billNo records.
              This action cannot be easily undone.
            </div>

            <div class="card border">
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="text-muted">Selected Records:</label>
                    <div><h4>{{ selectedBillNos.length }}</h4></div>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted">Total Amount:</label>
                    <div><h4>{{ formatPrice(calculateSelectedAmount()) }}</h4></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3">
              <label class="form-label">Archive Reason (Optional):</label>
              <input type="text"
                     class="form-control"
                     v-model="bulkArchiveReason"
                     placeholder="Enter reason...">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeBulkArchiveModal">Cancel</button>
            <button type="button" class="btn btn-danger" @click="archiveBulk()" :disabled="archiving">
              <i class="bx bx-archive me-1"></i>
              <span v-if="archiving">Archiving...</span>
              <span v-else>Archive All Selected</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- AUTO ARCHIVE MODAL -->
    <div class="modal fade" id="autoArchiveModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning">
            <h5 class="modal-title">
              <i class="bx bx-time me-2"></i>
              Auto Archive Duplicate BillNos
            </h5>
            <button type="button" class="btn-close" @click="closeAutoArchiveModal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info">
              <i class="bx bx-info-circle me-2"></i>
              <strong>How it works:</strong> This will search for duplicate billNos day-by-day and automatically archive duplicates, keeping only the first/original record for each billNo.
            </div>

            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label fw-bold">From Date <span class="text-danger">*</span></label>
                <input v-model="autoArchive.dateFrom"
                       class="form-control"
                       type="date"
                       :max="autoArchive.dateTo || undefined">
              </div>
              <div class="col-md-6">
                <label class="form-label fw-bold">To Date <span class="text-danger">*</span></label>
                <input v-model="autoArchive.dateTo"
                       class="form-control"
                       type="date"
                       :min="autoArchive.dateFrom || undefined">
              </div>
            </div>

            <div class="row g-3 mt-2">
              <div class="col-md-6">
                <label class="form-label fw-bold">Revenue Stream</label>
                <select class="form-select" v-model="autoArchive.incomeTypePrefix">
                  <option value="">All Streams</option>
                  <option v-for="prefix in prefixes" :key="prefix.incomeTypePrefix" :value="prefix.incomeTypePrefix">
                    {{ prefix.stream }} ({{ prefix.incomeTypePrefix }})
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-bold">Sub County</label>
                <select class="form-select" v-model="autoArchive.subCountyID">
                  <option value="">All Sub Counties</option>
                  <option v-for="county in subCounties" :key="county.subCountyID" :value="county.subCountyID">
                    {{ county.subCountyName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="alert alert-warning mt-3 mb-0">
              <i class="bx bx-info-circle me-2"></i>
              <strong>Note:</strong> You can pause and resume this process at any time. The first/original record for each billNo will always be kept.
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeAutoArchiveModal">
              Cancel
            </button>
            <button type="button"
                    class="btn btn-warning"
                    @click="startAutoArchive"
                    :disabled="!autoArchive.dateFrom || !autoArchive.dateTo">
              <i class="bx bx-play me-1"></i>
              Start Auto Archive
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- AUTO ARCHIVE PROGRESS MODAL -->
    <div class="modal fade" id="autoArchiveProgressModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title text-white">
              <i class="bx bx-time bx-spin me-2" v-if="!autoArchivePaused"></i>
              <i class="bx bx-pause me-2" v-else></i>
              Auto Archive {{ autoArchivePaused ? 'Paused' : 'in Progress' }}
            </h5>
          </div>
          <div class="modal-body">
            <!-- Overall Progress -->
            <div class="mb-4">
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold">Overall Progress</span>
                <span class="text-muted">{{ autoArchive.currentDayIndex }} of {{ autoArchive.totalDays }} days</span>
              </div>
              <div class="progress" style="height: 25px;">
                <div class="progress-bar progress-bar-striped"
                     :class="{ 'progress-bar-animated': !autoArchivePaused }"
                     role="progressbar"
                     :style="{width: autoArchive.overallProgress + '%'}"
                     :aria-valuenow="autoArchive.overallProgress"
                     aria-valuemin="0"
                     aria-valuemax="100">
                  {{ autoArchive.overallProgress }}%
                </div>
              </div>

              <!-- Time Remaining -->
              <div class="d-flex justify-content-between mt-2">
                <div>
                  <small class="text-muted">
                    <i class="bx bx-time me-1"></i>
                    Elapsed: <strong>{{ formatElapsedTime(autoArchive.startTime) }}</strong>
                  </small>
                </div>
                <div>
                  <small class="text-muted">
                    <i class="bx bx-hourglass me-1"></i>
                    Estimated Remaining: <strong>{{ estimatedTimeRemaining }}</strong>
                  </small>
                </div>
              </div>
            </div>

            <!-- Current Day Info -->
            <div class="card bg-light mb-3">
              <div class="card-body">
                <h6 class="card-title mb-2">
                  <i class="bx bx-calendar me-2"></i>Current Day:
                  <span class="text-primary">{{ autoArchive.currentDate }}</span>
                </h6>
                <div class="row g-3 mt-2">
                  <div class="col-4">
                    <div class="text-center">
                      <div class="text-muted small">Searched</div>
                      <div class="h5 mb-0 text-info">{{ autoArchive.currentDaySearched }}</div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="text-center">
                      <div class="text-muted small">Found</div>
                      <div class="h5 mb-0 text-warning">{{ autoArchive.currentDayFound }}</div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="text-center">
                      <div class="text-muted small">Archived</div>
                      <div class="h5 mb-0 text-success">{{ autoArchive.currentDayArchived }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Stats -->
            <div class="row g-3 mb-3">
              <div class="col-4">
                <div class="card border-left-primary">
                  <div class="card-body p-3">
                    <div class="text-muted small">Total Searched</div>
                    <div class="h5 mb-0 text-primary">{{ autoArchive.totalSearched }}</div>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="card border-left-warning">
                  <div class="card-body p-3">
                    <div class="text-muted small">Total Found</div>
                    <div class="h5 mb-0 text-warning">{{ autoArchive.totalFound }}</div>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="card border-left-success">
                  <div class="card-body p-3">
                    <div class="text-muted small">Total Archived</div>
                    <div class="h5 mb-0 text-success">{{ autoArchive.totalArchived }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Activity Log -->
            <div class="card">
              <div class="card-header bg-white">
                <h6 class="mb-0">
                  <i class="bx bx-list-ul me-2"></i>Activity Log
                </h6>
              </div>
              <div class="card-body p-0">
                <div class="activity-log" style="max-height: 200px; overflow-y: auto;">
                  <div v-for="(log, index) in autoArchive.logs"
                       :key="index"
                       class="log-entry p-2 border-bottom"
                       :class="log.type">
                    <small class="text-muted">{{ log.time }}</small>
                    <span class="ms-2">{{ log.message }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Close Button - Only when paused or stopped -->
            <button v-if="!autoArchiveInProgress"
                    type="button"
                    class="btn btn-secondary"
                    @click="closeAutoArchiveProgressModal">
              <i class="bx bx-x me-1"></i>
              Close
            </button>

            <!-- Pause/Resume Button -->
            <button v-if="!autoArchivePaused && autoArchiveInProgress"
                    type="button"
                    class="btn btn-warning"
                    @click="pauseAutoArchive">
              <i class="bx bx-pause me-1"></i>
              Pause
            </button>
            <button v-else-if="autoArchivePaused"
                    type="button"
                    class="btn btn-success"
                    @click="resumeAutoArchive">
              <i class="bx bx-play me-1"></i>
              Resume
            </button>

            <!-- Stop Button - Only when in progress or paused -->
            <button v-if="autoArchiveInProgress || autoArchivePaused"
                    type="button"
                    class="btn btn-danger"
                    @click="stopAutoArchive">
              <i class="bx bx-stop me-1"></i>
              Stop Process
            </button>
          </div>
        </div>
      </div>
    </div>

    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import { biller, execute } from "@/api";
import router from "@/router";
import moment from "moment";

export default {
  name: "DuplicateBillNoManagement",
  components: { NavigationBar },
  data() {
    return {
      // Tab management
      activeTab: 'duplicates',

      // Loading states
      loading: false,
      archiving: false,
      searched: false,

      // Filters
      filters: {
        dateFrom: '',
        dateTo: '',
        incomeTypePrefix: '',
        subCountyID: ''
      },

      // Data
      duplicates: [],
      prefixes: [],
      subCounties: [],

      // Selection
      selectedBillNos: [],

      // Archive
      bulkArchiveReason: '',
      singleArchiveReason: '',
      currentArchiveRecord: null,

      // Auto Archive Data
      autoArchive: {
        dateFrom: '',
        dateTo: '',
        incomeTypePrefix: '',
        subCountyID: '',
        currentDate: '',
        currentDayIndex: 0,
        totalDays: 0,
        overallProgress: 0,
        currentDaySearched: 0,
        currentDayFound: 0,
        currentDayArchived: 0,
        totalSearched: 0,
        totalFound: 0,
        totalArchived: 0,
        logs: [],
        pauseRequested: false,
        pausedDate: null,
        pausedDateIndex: 0,
        startTime: null,
        pausedTime: 0 // Total time paused in milliseconds
      },
      autoArchiveInProgress: false,
      autoArchivePaused: false,
      autoArchiveStopped: false,

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',

      // Modal instances
      bulkArchiveModal: null,
      singleArchiveModal: null,
      autoArchiveModal: null,
      autoArchiveProgressModal: null
    }
  },
  computed: {
    duplicatesOnly() {
      return this.duplicates.filter(item => item.record_type === 'DUPLICATE_BILLNO');
    },

    duplicatesFound() {
      return this.duplicatesOnly.length;
    },

    uniqueBillNos() {
      if (this.duplicates.length === 0) return 0;
      return new Set(this.duplicates.map(item => item.billNo)).size;
    },

    duplicateAmount() {
      return this.duplicatesOnly.reduce((sum, item) => sum + parseFloat(item.detailAmount || 0), 0);
    },

    allVisibleDuplicatesSelected() {
      const visibleDuplicates = this.duplicatesOnly.map(item => item.id);
      return visibleDuplicates.length > 0 && visibleDuplicates.every(id => this.selectedBillNos.includes(id));
    },

    // Estimated time remaining for auto archive
    estimatedTimeRemaining() {
      if (!this.autoArchive.startTime || this.autoArchive.currentDayIndex === 0) {
        return 'Calculating...';
      }

      // Calculate elapsed time in milliseconds
      const now = Date.now();
      const elapsed = now - this.autoArchive.startTime;

      // Calculate average time per day
      const avgTimePerDay = elapsed / this.autoArchive.currentDayIndex;

      // Calculate remaining days
      const remainingDays = this.autoArchive.totalDays - this.autoArchive.currentDayIndex;

      // Calculate estimated remaining time
      const estimatedRemaining = avgTimePerDay * remainingDays;

      // Format the time
      return this.formatDuration(estimatedRemaining);
    }
  },
  mounted() {
    this.cleanupModalIssues();
    this.setDefaultDates();
    this.loadDropdownData();

    setTimeout(() => {
      this.initializeModals();
    }, 500);

    this.menuAccess();
  },
  beforeDestroy() {
    this.destroyModals();
  },
  methods: {
    // Clean up modal issues
    cleanupModalIssues() {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');

      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
    },

    // Destroy modals
    destroyModals() {
      if (this.bulkArchiveModal) {
        this.bulkArchiveModal.dispose();
        this.bulkArchiveModal = null;
      }
      if (this.singleArchiveModal) {
        this.singleArchiveModal.dispose();
        this.singleArchiveModal = null;
      }
      if (this.autoArchiveModal) {
        this.autoArchiveModal.dispose();
        this.autoArchiveModal = null;
      }
      if (this.autoArchiveProgressModal) {
        this.autoArchiveProgressModal.dispose();
        this.autoArchiveProgressModal = null;
      }

      this.cleanupModalIssues();
    },

    // Initialize modals
    initializeModals() {
      this.$nextTick(() => {
        this.cleanupModalIssues();

        if (typeof window !== 'undefined' && window.bootstrap) {
          // Bulk Archive Modal
          const bulkArchiveModalEl = document.getElementById('bulkArchiveConfirmationModal');
          if (bulkArchiveModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(bulkArchiveModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.bulkArchiveModal = new bootstrap.Modal(bulkArchiveModalEl, {
              backdrop: true,
              keyboard: true,
              focus: true
            });

            bulkArchiveModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }

          // Single Archive Modal
          const singleArchiveModalEl = document.getElementById('singleArchiveConfirmationModal');
          if (singleArchiveModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(singleArchiveModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.singleArchiveModal = new bootstrap.Modal(singleArchiveModalEl, {
              backdrop: true,
              keyboard: true,
              focus: true
            });

            singleArchiveModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }

          // Auto Archive Modal
          const autoArchiveModalEl = document.getElementById('autoArchiveModal');
          if (autoArchiveModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(autoArchiveModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.autoArchiveModal = new bootstrap.Modal(autoArchiveModalEl, {
              backdrop: true,
              keyboard: true,
              focus: true
            });

            autoArchiveModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }

          // Auto Archive Progress Modal
          const autoArchiveProgressModalEl = document.getElementById('autoArchiveProgressModal');
          if (autoArchiveProgressModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(autoArchiveProgressModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.autoArchiveProgressModal = new bootstrap.Modal(autoArchiveProgressModalEl, {
              backdrop: 'static',
              keyboard: false
            });

            autoArchiveProgressModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }
        }
      });
    },

    // Set default dates
    setDefaultDates() {
      const today = moment().format('YYYY-MM-DD');
      const firstDayOfMonth = moment().startOf('month').format('YYYY-MM-DD');

      this.filters.dateFrom = firstDayOfMonth;
      this.filters.dateTo = today;
    },

    // Set date range
    setDateRange(range) {
      const today = moment();

      switch (range) {
        case 'today':
          this.filters.dateFrom = today.format('YYYY-MM-DD');
          this.filters.dateTo = today.format('YYYY-MM-DD');
          break;
        case 'week':
          this.filters.dateFrom = today.startOf('week').format('YYYY-MM-DD');
          this.filters.dateTo = moment().format('YYYY-MM-DD');
          break;
        case 'month':
          this.filters.dateFrom = today.startOf('month').format('YYYY-MM-DD');
          this.filters.dateTo = moment().format('YYYY-MM-DD');
          break;
      }

      this.clearResults();
    },

    // Clear results
    clearResults() {
      this.duplicates = [];
      this.selectedBillNos = [];
      this.searched = false;
    },

    // Load dropdown data
    async loadDropdownData() {
      await this.loadPrefixes();
      await this.loadSubCounties();
    },

    // Load prefixes
    async loadPrefixes() {
      try {
        const data = new FormData();
        data.append("function", "getIncomeTypePrefixesForDuplicates");

        const response = await execute(data, biller);
        if (response.data.success) {
          this.prefixes = response.data.data.prefixes || [];
        }
      } catch (error) {
        console.error('Error loading prefixes:', error);
      }
    },

    // Load sub counties
    async loadSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCountiesForDuplicates");

        const response = await execute(data, biller);
        if (response.data.success) {
          this.subCounties = response.data.data.subCounties || [];
        }
      } catch (error) {
        console.error('Error loading sub counties:', error);
      }
    },

    // Search for duplicate billNos
    async searchDuplicateBillNos() {
      if (!this.filters.dateFrom || !this.filters.dateTo) {
        this.showAlert('failed', 'Please select date range');
        return;
      }

      this.loading = true;
      this.duplicates = [];
      this.selectedBillNos = [];
      this.searched = true;

      try {
        const data = new FormData();
        data.append("function", "getDuplicateBillNumbers");
        data.append("dateFrom", this.filters.dateFrom);
        data.append("dateTo", this.filters.dateTo);

        if (this.filters.incomeTypePrefix) {
          data.append("incomeTypePrefix", this.filters.incomeTypePrefix);
        }

        if (this.filters.subCountyID) {
          data.append("subCountyID", this.filters.subCountyID);
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          this.duplicates = response.data.data.all_records || [];

          if (this.duplicates.length > 0) {
            const summary = response.data.data.summary;
            this.showAlert('success', `Found ${summary.duplicate_records} duplicate billNo records across ${summary.unique_bill_numbers_affected} unique billNos`);
          } else {
            this.showAlert('info', 'No duplicate billNo records found for the selected criteria');
          }
        } else {
          this.showAlert('failed', response.data.message || 'Error searching for duplicates');
        }
      } catch (error) {
        console.error('Error searching duplicates:', error);
        this.showAlert('failed', 'An error occurred while searching for duplicates');
      } finally {
        this.loading = false;
      }
    },

    // Select all duplicates
    selectAllDuplicates() {
      this.selectedBillNos = this.duplicatesOnly.map(item => item.id);
    },

    // Clear selection
    clearSelection() {
      this.selectedBillNos = [];
    },

    // Toggle select all visible
    toggleSelectAllVisible() {
      if (this.allVisibleDuplicatesSelected) {
        this.selectedBillNos = [];
      } else {
        this.selectAllDuplicates();
      }
    },

    // Show single archive confirmation
    showSingleArchiveConfirmation(record) {
      this.currentArchiveRecord = record;
      this.singleArchiveReason = '';

      this.cleanupModalIssues();

      setTimeout(() => {
        if (this.singleArchiveModal) {
          this.singleArchiveModal.show();
        }
      }, 100);
    },

    closeSingleArchiveModal() {
      if (this.singleArchiveModal) {
        this.singleArchiveModal.hide();
      }
      this.currentArchiveRecord = null;

      setTimeout(() => {
        this.cleanupModalIssues();
      }, 300);
    },

    // Show bulk archive confirmation
    showBulkArchiveConfirmation() {
      if (this.selectedBillNos.length === 0) {
        this.showAlert('failed', 'Please select records to archive');
        return;
      }

      this.bulkArchiveReason = '';

      this.cleanupModalIssues();

      setTimeout(() => {
        if (this.bulkArchiveModal) {
          this.bulkArchiveModal.show();
        }
      }, 100);
    },

    closeBulkArchiveModal() {
      if (this.bulkArchiveModal) {
        this.bulkArchiveModal.hide();
      }

      setTimeout(() => {
        this.cleanupModalIssues();
      }, 300);
    },

    // Archive single record
    async archiveSingle() {
      if (!this.currentArchiveRecord) return;

      this.archiving = true;

      try {
        const data = new FormData();
        data.append("function", "archiveDuplicateBillNumber");
        data.append("id", this.currentArchiveRecord.id);
        data.append("billNo", this.currentArchiveRecord.billNo);
        data.append("archivedBy", this.getUserEmail());
        data.append("archiveReason", this.singleArchiveReason || 'Duplicate billNo removal');

        const response = await execute(data, biller);

        if (response.data.success) {
          this.showAlert('success', 'Record archived successfully');
          this.closeSingleArchiveModal();
          await this.searchDuplicateBillNos(); // Refresh
        } else {
          this.showAlert('failed', response.data.message || 'Failed to archive record');
        }
      } catch (error) {
        console.error('Error archiving record:', error);
        this.showAlert('failed', 'An error occurred while archiving');
      } finally {
        this.archiving = false;
      }
    },

    // Archive bulk - one by one
    async archiveBulk() {
      if (this.selectedBillNos.length === 0) return;

      this.archiving = true;

      let successCount = 0;
      let failedCount = 0;
      const errors = [];

      try {
        // Close the confirmation modal first
        this.closeBulkArchiveModal();

        // Show progress message
        this.showAlert('info', `Archiving ${this.selectedBillNos.length} records one by one...`);

        // Loop through each selected record and archive one at a time
        for (let i = 0; i < this.selectedBillNos.length; i++) {
          const recordId = this.selectedBillNos[i];
          const record = this.duplicates.find(r => r.id === recordId);

          if (!record) {
            failedCount++;
            errors.push(`Record ID ${recordId} not found`);
            continue;
          }

          try {
            const data = new FormData();
            data.append("function", "archiveDuplicateBillNumber");
            data.append("id", record.id);
            data.append("billNo", record.billNo);
            data.append("archivedBy", this.getUserEmail());
            data.append("archiveReason", this.bulkArchiveReason || 'Bulk duplicate billNo removal');

            const response = await execute(data, biller);

            if (response.data.success) {
              successCount++;
              console.log(`✓ Archived record ${i + 1}/${this.selectedBillNos.length}: ID ${record.id}, BillNo ${record.billNo}`);
            } else {
              failedCount++;
              errors.push(`Record ID ${record.id}: ${response.data.message || 'Unknown error'}`);
              console.error(`✗ Failed to archive record ${i + 1}/${this.selectedBillNos.length}:`, response.data.message);
            }
          } catch (error) {
            failedCount++;
            errors.push(`Record ID ${record.id}: ${error.message}`);
            console.error(`✗ Error archiving record ${i + 1}/${this.selectedBillNos.length}:`, error);
          }

          // Small delay between requests to avoid overwhelming the server
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        // Show final result
        if (failedCount === 0) {
          this.showAlert('success', `Successfully archived all ${successCount} records!`);
        } else if (successCount === 0) {
          this.showAlert('failed', `Failed to archive all records. ${failedCount} failed.`);
        } else {
          this.showAlert('success', `Bulk archive completed: ${successCount} successful, ${failedCount} failed. Check console for details.`);
        }

        if (errors.length > 0) {
          console.error('Archive errors:', errors);
        }

        // Clear selection and refresh
        this.selectedBillNos = [];
        await this.searchDuplicateBillNos();

      } catch (error) {
        console.error('Error during bulk archive:', error);
        this.showAlert('failed', 'An error occurred during bulk archive');
      } finally {
        this.archiving = false;
      }
    },

    // Calculate selected amount
    calculateSelectedAmount() {
      let total = 0;
      this.selectedBillNos.forEach(id => {
        const record = this.duplicates.find(r => r.id === id);
        if (record) {
          total += parseFloat(record.detailAmount || 0);
        }
      });
      return total;
    },

    // Get user email
    getUserEmail() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return userInfo.email || userInfo.username || 'admin@county.go.ke';
    },

    // === AUTO ARCHIVE METHODS ===

    // Open Auto Archive Modal
    openAutoArchiveModal() {
      // Pre-fill with current filter dates
      this.autoArchive.dateFrom = this.filters.dateFrom;
      this.autoArchive.dateTo = this.filters.dateTo;
      this.autoArchive.incomeTypePrefix = this.filters.incomeTypePrefix;
      this.autoArchive.subCountyID = this.filters.subCountyID;

      this.cleanupModalIssues();

      setTimeout(() => {
        if (this.autoArchiveModal) {
          this.autoArchiveModal.show();
        }
      }, 100);
    },

    closeAutoArchiveModal() {
      if (this.autoArchiveModal) {
        this.autoArchiveModal.hide();
      }

      setTimeout(() => {
        this.cleanupModalIssues();
      }, 300);
    },

    // Start Auto Archive
    async startAutoArchive() {
      if (!this.autoArchive.dateFrom || !this.autoArchive.dateTo) {
        this.showAlert('failed', 'Please select date range');
        return;
      }

      // Close setup modal
      this.closeAutoArchiveModal();

      // Reset tracking
      this.autoArchiveInProgress = true;
      this.autoArchivePaused = false;
      this.autoArchiveStopped = false;

      this.autoArchive.currentDayIndex = 0;
      this.autoArchive.totalSearched = 0;
      this.autoArchive.totalFound = 0;
      this.autoArchive.totalArchived = 0;
      this.autoArchive.logs = [];
      this.autoArchive.startTime = Date.now(); // Start timer
      this.autoArchive.pausedTime = 0;

      // Calculate total days
      const startDate = moment(this.autoArchive.dateFrom);
      const endDate = moment(this.autoArchive.dateTo);
      this.autoArchive.totalDays = endDate.diff(startDate, 'days') + 1;

      // Add initial log
      this.addAutoArchiveLog('info', `Starting auto archive for ${this.autoArchive.totalDays} days (${this.autoArchive.dateFrom} to ${this.autoArchive.dateTo})`);

      // Show progress modal
      setTimeout(() => {
        if (this.autoArchiveProgressModal) {
          this.autoArchiveProgressModal.show();
        }
      }, 300);

      // Start processing
      await this.processAutoArchiveDays();
    },

    // Process days one by one
    async processAutoArchiveDays() {
      const startDate = moment(this.autoArchive.dateFrom);
      const endDate = moment(this.autoArchive.dateTo);

      let currentDate = this.autoArchive.pausedDate ? moment(this.autoArchive.pausedDate) : startDate.clone();

      while (currentDate.isSameOrBefore(endDate)) {
        // Check if paused
        if (this.autoArchive.pauseRequested) {
          this.autoArchivePaused = true;
          this.autoArchiveInProgress = false;
          this.autoArchive.pausedDate = currentDate.format('YYYY-MM-DD');
          this.autoArchive.pausedDateIndex = this.autoArchive.currentDayIndex;
          this.addAutoArchiveLog('warning', 'Process paused by user');
          return;
        }

        // Check if stopped
        if (this.autoArchiveStopped) {
          this.addAutoArchiveLog('error', 'Process stopped by user');
          this.autoArchiveInProgress = false;
          return;
        }

        // Process this day
        this.autoArchive.currentDate = currentDate.format('YYYY-MM-DD');
        this.autoArchive.currentDayIndex++;

        this.addAutoArchiveLog('info', `Processing ${this.autoArchive.currentDate}...`);

        await this.processDateForDuplicates(currentDate.format('YYYY-MM-DD'));

        // Update overall progress
        this.autoArchive.overallProgress = Math.round((this.autoArchive.currentDayIndex / this.autoArchive.totalDays) * 100);

        // Move to next day
        currentDate.add(1, 'day');

        // Small delay between days
        await new Promise(resolve => setTimeout(resolve, 500));
      }

      // Completed
      this.autoArchiveInProgress = false;
      this.addAutoArchiveLog('success', `✓ Auto archive completed! Total: ${this.autoArchive.totalArchived} records archived from ${this.autoArchive.totalFound} duplicates found.`);
      this.showAlert('success', `Auto archive completed! ${this.autoArchive.totalArchived} records archived.`);
    },

    // Process a single date for duplicates
    async processDateForDuplicates(date) {
      // Reset current day stats
      this.autoArchive.currentDaySearched = 0;
      this.autoArchive.currentDayFound = 0;
      this.autoArchive.currentDayArchived = 0;

      try {
        // Search for duplicates on this specific date
        const data = new FormData();
        data.append("function", "getDuplicateBillNumbers");
        data.append("dateFrom", date);
        data.append("dateTo", date);

        if (this.autoArchive.incomeTypePrefix) {
          data.append("incomeTypePrefix", this.autoArchive.incomeTypePrefix);
        }

        if (this.autoArchive.subCountyID) {
          data.append("subCountyID", this.autoArchive.subCountyID);
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          const records = response.data.data.all_records || [];
          this.autoArchive.currentDaySearched = records.length;
          this.autoArchive.totalSearched += records.length;

          // Filter only duplicates (not FIRST_RECORD)
          const duplicates = records.filter(r => r.record_type === 'DUPLICATE_BILLNO');
          this.autoArchive.currentDayFound = duplicates.length;
          this.autoArchive.totalFound += duplicates.length;

          if (duplicates.length > 0) {
            this.addAutoArchiveLog('processing', `Found ${duplicates.length} duplicate(s) on ${date}`);

            // Archive each duplicate one by one
            for (const duplicate of duplicates) {
              // Check pause/stop
              if (this.autoArchive.pauseRequested || this.autoArchiveStopped) {
                return;
              }

              try {
                const archiveData = new FormData();
                archiveData.append("function", "archiveDuplicateBillNumber");
                archiveData.append("id", duplicate.id);
                archiveData.append("billNo", duplicate.billNo);
                archiveData.append("archivedBy", this.getUserEmail());
                archiveData.append("archiveReason", 'Auto archive - duplicate billNo removal');

                const archiveResponse = await execute(archiveData, biller);

                if (archiveResponse.data.success) {
                  this.autoArchive.currentDayArchived++;
                  this.autoArchive.totalArchived++;
                } else {
                  this.addAutoArchiveLog('error', `Failed to archive record ${duplicate.id}: ${archiveResponse.data.message}`);
                }
              } catch (error) {
                this.addAutoArchiveLog('error', `Error archiving record ${duplicate.id}: ${error.message}`);
              }

              // Small delay between archives
              await new Promise(resolve => setTimeout(resolve, 100));
            }

            this.addAutoArchiveLog('success', `✓ Archived ${this.autoArchive.currentDayArchived} record(s) on ${date}`);
          } else {
            this.addAutoArchiveLog('info', `No duplicates found on ${date}`);
          }
        } else {
          this.addAutoArchiveLog('error', `Error searching ${date}: ${response.data.message}`);
        }
      } catch (error) {
        this.addAutoArchiveLog('error', `Exception on ${date}: ${error.message}`);
      }
    },

    // Add log to auto archive
    addAutoArchiveLog(type, message) {
      this.autoArchive.logs.unshift({
        time: moment().format('HH:mm:ss'),
        type: type,
        message: message
      });

      // Keep only last 50 logs
      if (this.autoArchive.logs.length > 50) {
        this.autoArchive.logs = this.autoArchive.logs.slice(0, 50);
      }
    },

    // Pause auto archive
    pauseAutoArchive() {
      this.autoArchive.pauseRequested = true;
      this.addAutoArchiveLog('warning', 'Pause requested...');
    },

    // Resume auto archive
    async resumeAutoArchive() {
      this.autoArchive.pauseRequested = false;
      this.autoArchivePaused = false;
      this.autoArchiveInProgress = true;

      this.addAutoArchiveLog('info', 'Resuming auto archive...');

      await this.processAutoArchiveDays();
    },

    // Stop auto archive
    stopAutoArchive() {
      this.autoArchiveStopped = true;
      this.autoArchiveInProgress = false;
      this.autoArchivePaused = false;

      this.addAutoArchiveLog('error', 'Process stopped by user');
      this.showAlert('info', 'Auto archive process stopped');
    },

    // Close auto archive progress modal
    closeAutoArchiveProgressModal() {
      if (this.autoArchiveProgressModal) {
        this.autoArchiveProgressModal.hide();
      }

      setTimeout(() => {
        this.cleanupModalIssues();

        // Reset auto archive state
        this.autoArchiveInProgress = false;
        this.autoArchivePaused = false;
        this.autoArchiveStopped = false;
        this.autoArchive.pauseRequested = false;
      }, 300);
    },

    // Format elapsed time
    formatElapsedTime(startTime) {
      if (!startTime) return '0s';

      const elapsed = Date.now() - startTime;
      return this.formatDuration(elapsed);
    },

    // Format duration in milliseconds to human readable
    formatDuration(milliseconds) {
      if (!milliseconds || milliseconds < 0) return '0s';

      const seconds = Math.floor(milliseconds / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) {
        const remainingHours = hours % 24;
        const remainingMinutes = minutes % 60;
        return `${days}d ${remainingHours}h ${remainingMinutes}m`;
      } else if (hours > 0) {
        const remainingMinutes = minutes % 60;
        const remainingSeconds = seconds % 60;
        return `${hours}h ${remainingMinutes}m ${remainingSeconds}s`;
      } else if (minutes > 0) {
        const remainingSeconds = seconds % 60;
        return `${minutes}m ${remainingSeconds}s`;
      } else {
        return `${seconds}s`;
      }
    },

    // Format price
    formatPrice(amount) {
      if (!amount) return 'KES 0.00';
      return 'KES ' + parseFloat(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    // Format date time
    formatDateTime(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD/MM/YYYY HH:mm');
    },

    // Show alert
    showAlert(type, msg) {
      this.message = msg;
      this.alert.success = type === 'success';
      this.alert.info = type === 'info';
      this.alert.failed = type === 'failed';

      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    // Menu access
    menuAccess() {
      const menu_id = '21';
      const get_param = {
        menu_id: menu_id
      };

      localStorage.setItem('module_accessed', JSON.stringify(get_param));
    },

    // Navigate
    gotTo(route) {
      router.push({ name: route });
    }
  }
}
</script>

<style scoped>
/* Modal backdrop */
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* Stats cards */
.mini-stats-wid {
  transition: all 0.3s ease;
}

.mini-stats-wid:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.mini-stats-wid.border-warning {
  border-left: 3px solid #ffc107;
}

.mini-stats-wid.border-info {
  border-left: 3px solid #17a2b8;
}

.mini-stats-wid.border-danger {
  border-left: 3px solid #dc3545;
}

.mini-stats-wid.border-success {
  border-left: 3px solid #28a745;
}

/* Table styles */
.table-success {
  background-color: rgba(40, 167, 69, 0.1) !important;
}

.table-warning {
  background-color: rgba(255, 193, 7, 0.1) !important;
}

.table-light {
  background-color: rgba(248, 249, 250, 0.5) !important;
}

/* Tabs */
.nav-tabs .nav-link {
  color: #495057;
}

.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

/* Activity log */
.activity-log {
  background-color: #f8f9fa;
}

.log-entry {
  font-size: 0.875rem;
}

.log-entry.success {
  border-left: 3px solid #28a745;
  background-color: rgba(40, 167, 69, 0.05);
}

.log-entry.error {
  border-left: 3px solid #dc3545;
  background-color: rgba(220, 53, 69, 0.05);
}

.log-entry.warning {
  border-left: 3px solid #ffc107;
  background-color: rgba(255, 193, 7, 0.05);
}

.log-entry.info {
  border-left: 3px solid #17a2b8;
  background-color: rgba(23, 162, 184, 0.05);
}

.log-entry.processing {
  border-left: 3px solid #0d6efd;
  background-color: rgba(13, 110, 253, 0.05);
}

.border-left-primary {
  border-left: 3px solid #0d6efd;
}

.border-left-warning {
  border-left: 3px solid #ffc107;
}

.border-left-success {
  border-left: 3px solid #28a745;
}
</style>